import { combineReducers } from 'redux';
import Auth                from './AuthReducer';
import Data                from './DataReducer';
import User                from './UserReducer';
import AppHeader           from './AppHeaderReducer';
import Assets              from './AssetsReducer';
import Directions          from './DirectionsReducer';
import GeoLocation         from './GeoLocationReducer';
import Closest             from './ClosestReducer';
import Message             from './MessageReducer';
import Map                 from './MapReducer';
import Pages               from './PagesReducer';
import Places              from './PlacesReducer';
import Place               from './PlaceReducer';
import Filter              from './FilterReducer';
import View                from './ViewReducer';

const rootReducer = combineReducers({
    auth      : Auth,
    appHeader : AppHeader,
    data      : Data,
    user      : User,
    assets    : Assets,
    directions: Directions,
    geo       : GeoLocation,
    closest   : Closest,
    map       : Map,
    message   : Message,
    pages     : Pages,
    places    : Places,
    place     : Place,
    filter    : Filter,
    view      : View
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js